import { render, staticRenderFns } from "./spinnerMobileButton.vue?vue&type=template&id=fba8f390&"
import script from "./spinnerMobileButton.vue?vue&type=script&lang=ts&"
export * from "./spinnerMobileButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports